import type { IMkInputField } from '@typescript'
import type { IMkBookingError } from '@book/types'
import { EWaitlistAction, type EWaitlistStepName, type IWaitlistDraft, type IWaitlistStep, type WaitlistAction } from '../../types'

export const setWaitlistDraft = (waitlistDraft: IWaitlistDraft): WaitlistAction => ({
  type: EWaitlistAction.SET_WAITLIST_DRAFT,
  payload: waitlistDraft,
})

export const updateField = (step: IWaitlistStep, fieldName: string, fieldValue: IMkInputField['value'], fieldType: string): WaitlistAction => ({
  type: EWaitlistAction.UPDATE_FIELD,
  payload: {
    stepName: step.name as EWaitlistStepName | string,
    fieldName,
    fieldValue,
    fieldType,
  },
})

export const setWaitlistLoading = (isLoading: boolean): WaitlistAction => ({
  type: EWaitlistAction.SET_LOADING,
  payload: isLoading,
})

export const setWaitlistError = (error: IMkBookingError): WaitlistAction => ({
  type: EWaitlistAction.SET_ERROR,
  payload: error,
})

export const clearWaitlistError = (): WaitlistAction => ({
  type: EWaitlistAction.CLEAR_ERROR,
})

export const clearWaitlistDraft = (): WaitlistAction => ({
  type: EWaitlistAction.CLEAR_WAITLIST_DRAFT,
})
